var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { ref: "textTooltipWrap", staticClass: "erp-tml-common-text-tooltip-wrap" },
    [
      _vm.text
        ? _c(
            "a-tooltip",
            {
              attrs: {
                overlayClassName: _vm.overlayClassName,
                visible: _vm.isShowTooltip,
                placement: _vm.placement,
              },
            },
            [
              _c("template", { slot: "title" }, [
                _c("span", [_vm._v(_vm._s(_vm.text))]),
              ]),
              _vm.isLink
                ? _c(
                    "a",
                    {
                      class: _vm.textClassName,
                      style: _vm.textStyle,
                      attrs: { href: _vm.linkUrl, target: "_blank" },
                      on: {
                        mouseover: _vm.hanldeElTooltip,
                        mouseleave: _vm.closeElTooltip,
                      },
                    },
                    [_vm._v(_vm._s(_vm.text))]
                  )
                : _c(
                    "p",
                    {
                      class: _vm.textClassName,
                      style: _vm.textStyle,
                      on: {
                        mouseover: _vm.hanldeElTooltip,
                        mouseleave: _vm.closeElTooltip,
                      },
                    },
                    [_vm._v(_vm._s(_vm.text))]
                  ),
              _vm._t("suffix"),
            ],
            2
          )
        : _c("p", [_vm._v(_vm._s(_vm.noData))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }